import { memo } from 'react';
import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';

import AddScenarioFormV1 from './AddScenarioFormV1';

interface AddScenarioModalV1Properties {
  isOpen: boolean;
  onClose: () => void;
}

const AddScenarioModalV1 = memo(({ isOpen, onClose }: AddScenarioModalV1Properties) => {
  const ModalContentAny: any = ModalContent;
  const ModalBodyAny: any = ModalBody;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick
      returnFocusOnClose={false}
      blockScrollOnMount={false}
    >
      <ModalOverlay bg='blackAlpha.600' />
      <ModalContentAny
        p={BUILDER_MODE_V1_LAYOUT.addScenarioPanelPadding}
        bg={BUILDER_MODE_V1_TOKENS.white}
        borderRadius={BUILDER_MODE_V1_LAYOUT.addScenarioPanelRadius}
        maxW={BUILDER_MODE_V1_LAYOUT.addScenarioPanelWidth}
        boxShadow={BUILDER_MODE_V1_LAYOUT.scenarioPopoverShadow}
      >
        <ModalBodyAny p={0}>
          {isOpen ? <AddScenarioFormV1 onCancel={onClose} /> : null}
        </ModalBodyAny>
      </ModalContentAny>
    </Modal>
  );
});

AddScenarioModalV1.displayName = 'AddScenarioModalV1';

export default AddScenarioModalV1;
